function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 1.667c-.917 0-1.658.75-1.658 1.666l-.009 13.334c0 .916.742 1.666 1.659 1.666H15c.917 0 1.667-.75 1.667-1.666v-10l-5-5H5zM10.833 7.5V2.917L15.417 7.5h-4.584z",
  fill: "#879097"
});

function SvgIconDocGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgIconDocGray;